// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 3164 ? "f6ef2be3" : chunkId) + "." + {"790":"18f625e58c140a13","2446":"789b8bb555923c81","3164":"1f5c95edb72477ab","9359":"fb9e309d406a026b"}[chunkId] + ".js";
};